/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class RomanEmpireBigWinCountUp extends BitmapWinCountUp {

    private _bigWinSpineAnim: PIXI.spine.Spine;
    private _shadow: PIXI.Sprite;
    private _finalScaleAmt: number = 0;
    private _level = 0;

    constructor() {
        super({
            font: {
                name: "NumbersWinCountUp",
                size: 45
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    protected initAnimations(): void {
        this._bigWinSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("bigWinLevels"));
        this._shadow = new PIXI.Sprite(GameResources.getTextures("Shadow")[0]);
        super.initAnimations();
        this._countUpContainer.addChildAt(this._shadow, 0);
        this._countUpContainer.addChildAt(this._bigWinSpineAnim, 0);
        // this._shadow.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, GameConfig.instance.GAME_HEIGHT * 0.56);
        // this._bigWinSpineAnim.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, GameConfig.instance.GAME_HEIGHT * 0.56);
        // StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BIG_WIN.name).addChildAt(this._shadow, 0);
        // StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BIG_WIN.name).addChildAt(this._bigWinSpineAnim, 0);
        this._bigWinSpineAnim.alpha = 0;
        this._shadow.alpha = 0;
        this._shadow.anchor.set(0.5);
        this._shadow.scale.set(3);
    }

    public getCountUpAnimation(from: number, to: number, duration: number, level: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();

        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._bigWinSpineAnim.state.setAnimation(0, "tickup_loop", true);
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration: duration,
                ease: from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            this.getPumpUpAnimation(level, duration),
            TweenLite.to(this._bigWinSpineAnim, 0.001, {alpha: 1}),
            TweenLite.to(this._shadow, 0.001, {alpha: 0.5}),
        ]);
        return timeline;
    }


    private getPumpUpAnimation(level: number, duration: number): TimelineLite {
        let levelStr = "";
        if (level === 0) {
            levelStr = "bigwin";
        } else if (level === 1) {
            levelStr = "megawin";
        } else if (level === 2) {
            levelStr = "supermegawin";
        }
        const tl: TimelineLite = new TimelineLite();
        const bigWinSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("bigWinLevels"));
        const startAnim: SpineTween = new SpineTween(bigWinSpine, 0, `${levelStr}_start`, 0);
        const endAnim: SpineTween = new SpineTween(bigWinSpine, 0, `${levelStr}_end`, 0);

        tl.add(this.getCountUpScaleInOutTl(level, 0), 0);
        tl.add(this.getCountUpScaleInOutTl(level, 1, duration - endAnim.totalDuration() - startAnim.totalDuration()), startAnim.totalDuration());
        tl.add(this.getCountUpScaleInOutTl(level, 2), duration - endAnim.totalDuration());
        return tl;
    }

    protected onResize(resizeData: IResizeData): void {
        super.onResize && super.onResize(resizeData);
        this._finalScaleAmt = this._resizeData.orientation === Orientation.PORTRAIT ? 0.7 + this._level * 0.2 : 1 + this._level * 0.2;

        this._countUpContainer.scale.set(this._finalScaleAmt);
    }

    private getCountUpScaleInOutTl(level: number, animLevel: number, duration?: number): TimelineLite {
        let tl: TimelineLite = new TimelineLite();

        this._finalScaleAmt = this._resizeData.orientation === Orientation.PORTRAIT ? 0.7 + level * 0.2 : 1 + level * 0.2;
        this._level = level;
        if (animLevel === 0) {
            // tl.add(() => {
            //     this._shadow.scale.set(1);
            //     const scaleAmt = this._countUp.width * 2 / this._shadow.width;
            //     TweenLite.to(this._shadow.scale, 0.01, {x: scaleAmt, y: scaleAmt})
            // });
            tl.add(TweenLite.to(this._countUpContainer.scale, 0, {x: 0, y: 0}));
            tl.add(TweenLite.to(this._countUpContainer.scale, 0.1333, {
                x: this._finalScaleAmt + 0.5,
                y: this._finalScaleAmt + 0.5
            }));
            tl.add(TweenLite.to(this._countUpContainer.scale, 0.267, {x: this._finalScaleAmt, y: this._finalScaleAmt}));
        } else if (animLevel === 1) {
            // let i = 0;
            // do{
            //     i++;
            //     tl.add(TweenLite.to(this._countUpContainer.scale, 0, {x: 1, y: 1}));
            //     tl.add(TweenLite.to(this._countUpContainer.scale, 0.2333, {x: 1.1, y: 1.1}) );
            //     tl.add(TweenLite.to(this._countUpContainer.scale, 0.2333, {x: 1, y: 1}) );
            //     tl.add(TweenLite.to(this._countUpContainer.scale, 0.2333, {x: 1.1, y: 1.1}) );
            //     tl.add(TweenLite.to(this._countUpContainer.scale, 0.2333, {x: 1, y: 1}) );
            // }while (i < (duration || 1)/1);

        } else if (animLevel === 2) {
            if (level === 2) {
                // tl.add(() => {
                //     this._shadow.scale.set(1);
                //     const scaleAmt = this._countUp.width * 2 / this._shadow.width;
                //     TweenLite.to(this._shadow.scale, 0.01, {x: scaleAmt, y: scaleAmt})
                // });
                //(level != 2) && tl.add(TweenLite.to({}, 0.333, {}));
                tl.add(TweenLite.to(this._countUpContainer.scale, 0, {x: this._finalScaleAmt, y: this._finalScaleAmt}));
                tl.add(TweenLite.to(this._countUpContainer.scale, 0.1, {x: 1.15, y: 1.15}));
                tl.add(TweenLite.to(this._countUpContainer.scale, 0.333, {}));
            }
        }
        return tl;
    }

    protected getAbortAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x: 0.5, y: 0.5},
                {
                    x: 1,
                    y: 1,
                    ease: Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01})
        ]);

        return timeline;
    }

    public getEndingAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        timeline.add([
            TweenLite.to(this._countUp, 0.2, {alpha: 0}),
            TweenLite.to(this._bigWinSpineAnim, 0.2, {alpha: 0}),
            TweenLite.to(this._shadow, 0.2, {alpha: 0}),
        ], `+=0.8`); // stay a while after count up.

        return timeline;
    }
}